// pages/cards/DataPage.js
import React, { useEffect, useMemo, useState } from 'react';
import SmartDataTable from '../../components/SmartDataTable';
import { tableConfig } from './tableConfig';
import { useOrg } from '../orgs/org-context';

export default function CardDesignsDataPage() {
  const [tableKey, setTableKey] = useState(0);
  const { activeOrgId, activeOrg } = useOrg();

  // Resolve current orgId consistently with the rest of the app
  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";

  // Remount the table when org changes to force a fresh fetch
  useEffect(() => {
    setTableKey((k) => k + 1);
  }, [orgId]);

  return (
    <div className="datatable-page">
      <div className="datatable-header-row" style={{ justifyContent: 'space-between' }}>
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>Card Designs</div>
      </div>

      <SmartDataTable
        key={tableKey}
        config={{
          ...tableConfig,
          // ensure header gets sent even if the table doesn’t re-run effect
          orgIdOverride: orgId,
          // keep actions consistent with your other lists (optional View)
          buttons: [
            { label: 'Edit', color: 'green', action: '/cards/{_id}' },
            { label: 'Delete', color: 'red', action: 'delete' },
          ],
        }}
      />
    </div>
  );
}
